import { ITheme } from '@quicktools/shared-components/styles';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles<
  string,
  { labelPaddingTop: number; labelPaddingTopMobile: number },
  ITheme
>(
  {
    chips: {
      marginTop: 16,
      display: 'flex',
      flexFlow: 'row wrap',
      gap: 8,
    },
    textLabel: {
      color: '#808080',
      fontSize: 16,
    },
    error: {
      '& > span': {
        border: '2px solid var(--x-error-color) !important',
      },
    },
    chip: {
      minWidth: 60,
      borderWidth: 1,
      borderColor: 'inherit',
      borderStyle: 'solid',
    },
    button: {
      backgroundColor: 'var(--x-bg-12) !important',
    },
  },
  { name: 'generic-chips' },
);
export default useStyles;
